import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Cpv } from '@app/modules/ceoe/models/tender';
import { TendersService } from '@app/modules/ceoe/services/tenders.service';
import { GetCpv, GetCpvs } from '@app/modules/ceoe/store/tenders/tenders.actions';
import { TendersStateService } from '@app/modules/ceoe/store/tenders/tenders.service';
import { UtilsService } from '@app/services/utils.service';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-tenders-search-filters-organism',
  templateUrl: './tenders-search-filters-organism.component.html',
  styleUrls: ['./tenders-search-filters-organism.component.scss'],
})
export class TendersSearchFiltersOrganismComponent implements OnInit, OnChanges {
  @Input()
  selectedSectoresInput = [];

  @Output()
  selectedSectoresOutput: EventEmitter<string[]> = new EventEmitter<string[]>();

  filtersForm: FormGroup;
  filtersDateRangeForm: FormGroup;
  loading = false;

  dropdownSectoresList = [];
  selectedSectoresItems = [];
  dropdownSectoresSettings = {
    text: 'Ámbito',
    noDataLabel: '',
    searchPlaceholderText: 'Buscar...',
    enableSearchFilter: true,
    badgeShowLimit: 5,
    showCheckbox: true,
  };

  constructor(
    public tendersStateService: TendersStateService,
    public tendersService: TendersService,
    private fb: FormBuilder,
    private actions: Actions,
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef
  ) {
    this.filtersForm = this.fb.group({
      sections: [[]],
    });

    this.filtersForm.controls.sections.valueChanges.subscribe((v) => {
      this.selectedSectoresOutput.emit(v.map((v) => v.id));
    });

    setTimeout(() => {
      this.setSearchInputListener();
    }, 0);
  }

  ngOnInit(): void {
    // this.populateSections();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.selectedSectoresInput &&
      changes.selectedSectoresInput.currentValue &&
      changes.selectedSectoresInput.currentValue.length > 0
    ) {
      this.filtersForm.controls.sections.setValue(
        (changes.selectedSectoresInput.currentValue as string[]).map((cv) => {
          return {
            id: cv,
            itemName: cv,
            name: cv,
          };
        })
      );
    } else {
      this.filtersForm.controls.sections.setValue([]);
    }
  }

  populateSections(): void {
    this.actions.pipe(ofActionSuccessful(GetCpvs)).subscribe(() => {
      this.setDropdownItems();
    });

    this.tendersStateService.getCpvs();
  }

  setDropdownItems(): void {
    // this.dropdownSectoresList = this.tendersStateService.cpvs.map((c) => {
    //   return {
    //     id: Number(c.organo),
    //     itemName: c.organo,
    //     name: this.utilsService.removeDiacritics(c.descripcion),
    //   };
    // });
  }

  setSearchInputListener(): void {
    const inputElement: any = document.querySelector('#organismos-selector input.c-input');
    const inputObservable = fromEvent(inputElement, 'input');

    inputObservable.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
      if (inputElement.value && inputElement.value.length >= 3) {
        this.setLoader();
        this.getCpvItemsDetail(inputElement.value);
      }
    });
  }

  onItemSelect(item: any): void {
    // this.getCpvItemsDetail(item);
  }

  getCpvItemsDetail(organo: string): void {
    this.tendersService.getOrganoDetailItems({ organo }).subscribe((data) => {
      // (document.querySelector('#organismos-selector input.c-input') as HTMLInputElement).value = '';
      this.removeLoader();
      this.cdr.detectChanges();

      this.dropdownSectoresList = data.items.map((i) => {
        return {
          id: i.organo,
          itemName: i.organo,
          name: this.utilsService.removeDiacritics(i.organo),
        };
      });
    });
  }

  setLoader(): void {
    this.dropdownSectoresList = [];
    const container = document.createElement('div');
    const loader = document.createElement('div');
    const text = document.createElement('p');
    container.appendChild(loader);
    container.appendChild(text);
    container.className = 'container-loader';
    container.style.display = 'flex';
    container.style.alignItems = 'flex-end';
    container.style.gap = '2px';
    loader.className = 'custom-pure-loader ';
    text.textContent = 'Cargando organismos convocantes...';
    const parentElement: any = document.querySelector('#organismos-selector .lazyContainer');
    parentElement.insertBefore(container, parentElement.firstChild);
  }

  removeLoader(): void {
    document.querySelector('#organismos-selector .lazyContainer .container-loader')?.remove();
    this.setDropdownItems();

    var clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });

    document.querySelector('#organismos-selector input.c-input').dispatchEvent(clickEvent);
    this.cdr.detectChanges();
  }
}
